import React, { forwardRef, useState } from 'react';
import { animated, easings, useSpring } from '@react-spring/web';

const ModalBackdrop = forwardRef(({
  children,
  duration,
  style: styleProps,
  onClickFn,
  show },
ref
) => {
  const defaultStyle = {
    backgroundColor: 'rgba(18,18,18,.5)'
  };
  // setting display values
  const [display, setDisplay] = useState('none');
  // spring values
  const fadeInProps = useSpring({
    opacity: show ? 1 : 0,
    config: {
      duration,
      easing: easings.easeOutCirc
    },
    onRest: () => {
      // Check the animation's target value to set display accordingly
      if (!show) {
        setDisplay('none');
        document.body.style.overflowY = 'auto';
      }
    },
    onStart: () => {
      // If starting the showing animation, ensure display is block
      if (show) {
        setDisplay('block');
        document.body.style.overflowY = 'hidden'; // locks the body
      }
    }
  });

  return (
    <animated.div
      ref={ref}
      className="ModalBackdrop"
      style={{
        ...defaultStyle,
        ...fadeInProps,
        ...styleProps,
        display,
        zIndex: 'none' === display ? '-1029' : '1029'
      }}
      {...(onClickFn && { onClick: onClickFn })}
    >
      {children}
    </animated.div>
  );
});

export default ModalBackdrop;
